import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'

import MetricListForm from './MetricListForm'
import { storeMetricList } from '../services'
import { handleError } from '../../../helpers'

export default function NewMetricListForm({ reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm();

	const onSubmit = values => {
		storeMetricList(values)
			.then(() => {
				message.success('Listado creado exitosamente.')
				reload()
				reset()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<MetricListForm register={register} errors={errors} />
				<Button type="submit" color="primary">Crear Listado de Metricas</Button>
			</Form>
		</React.Fragment>
	)
}